type SidebarScreenMatcher = {
  name: string
  matches(pathname: string): boolean
}

const normalizePathname = (pathname: string) => {
  if (!pathname) return '/'

  if (pathname === '/') return pathname

  return pathname.replace(/\/+$/, '')
}

const isExactPath = (pathname: string, path: string) => pathname === path

const isPathPrefix = (pathname: string, prefix: string) =>
  pathname === prefix || pathname.startsWith(`${prefix}/`)

const SIDEBAR_PAGE_MATCHERS: SidebarScreenMatcher[] = [
  { name: 'Início', matches: (pathname) => pathname === '/' || isPathPrefix(pathname, '/home') },
  { name: 'Perfil', matches: (pathname) => isPathPrefix(pathname, '/perfil') },
  { name: 'Carteira', matches: (pathname) => isPathPrefix(pathname, '/carteira') },
  {
    name: 'Oportunidades',
    matches: (pathname) =>
      isPathPrefix(pathname, '/oportunidades') || isPathPrefix(pathname, '/minha-organizacao')
  },
  { name: 'Fraudes', matches: (pathname) => isPathPrefix(pathname, '/fraudes') },
  { name: 'Conteúdos', matches: (pathname) => isPathPrefix(pathname, '/conteudos') },
  { name: 'Painéis', matches: (pathname) => isPathPrefix(pathname, '/paineis') },
  { name: 'Pesquisas', matches: (pathname) => isPathPrefix(pathname, '/pesquisas') },
  { name: 'Contrata Já', matches: (pathname) => isPathPrefix(pathname, '/contrata-ja') },
  {
    name: 'Contrat. Bens',
    matches: (pathname) => isPathPrefix(pathname, '/contratacao-bens')
  },
  { name: 'Contratação', matches: (pathname) => isPathPrefix(pathname, '/contratacao') },
  {
    name: 'Seu Jeito',
    matches: (pathname) => isPathPrefix(pathname, '/seu-jeito-financeira')
  },
  {
    name: 'Premio+',
    matches: (pathname) => isPathPrefix(pathname, '/marketing/premio-plus')
  },
  { name: 'Hora em Hora', matches: (pathname) => isPathPrefix(pathname, '/hora-em-hora') }
]

const SIDEBAR_TERMS_MATCHERS: SidebarScreenMatcher[] = [
  { name: 'Início', matches: (pathname) => isExactPath(pathname, '/home') },
  { name: 'Perfil', matches: (pathname) => isExactPath(pathname, '/perfil') },
  {
    name: 'Carteira',
    matches: (pathname) =>
      isExactPath(pathname, '/carteira/contatos') || isExactPath(pathname, '/carteira/tabs')
  },
  { name: 'Oportunidades', matches: (pathname) => isExactPath(pathname, '/oportunidades') },
  { name: 'Fraudes', matches: (pathname) => isExactPath(pathname, '/fraudes') },
  { name: 'Conteúdos', matches: (pathname) => isExactPath(pathname, '/conteudos') },
  { name: 'Painéis', matches: (pathname) => isExactPath(pathname, '/paineis') },
  { name: 'Pesquisas', matches: (pathname) => isExactPath(pathname, '/pesquisas') },
  { name: 'Contrata Já', matches: (pathname) => isExactPath(pathname, '/contrata-ja') },
  {
    name: 'Contrat. Bens',
    matches: (pathname) => pathname.startsWith('/contratacao-bens/')
  },
  { name: 'Contratação', matches: (pathname) => pathname.startsWith('/contratacao/') },
  {
    name: 'Seu Jeito',
    matches: (pathname) => isExactPath(pathname, '/seu-jeito-financeira')
  },
  {
    name: 'Premio+',
    matches: (pathname) => isExactPath(pathname, '/marketing/premio-plus')
  },
  {
    name: 'Notificações',
    matches: (pathname) => isExactPath(pathname, '/notificacoes')
  }
]

const findSidebarScreenName = (pathname: string, matchers: SidebarScreenMatcher[]) => {
  const normalizedPathname = normalizePathname(pathname)

  return matchers.find(({ matches }) => matches(normalizedPathname))?.name ?? null
}

export const getSidebarPageName = (pathname: string) =>
  findSidebarScreenName(pathname, SIDEBAR_PAGE_MATCHERS)

export const getSidebarTermsScreenName = (pathname: string) =>
  findSidebarScreenName(pathname, SIDEBAR_TERMS_MATCHERS)
